import events from 'events.js';
import http from 'http.js';
import ko from 'knockout';

class SearchResult {
    constructor() {
        this.selectable = ko.observable(true);
        this.text = ko.observable('');
        this.type = ko.observable('');
        this.url = ko.observable('');

        this.template = ko.pureComputed(
            () => `${this.type().toLowerCase()}-result`,
        );
    }

    load(data) {
        this.text(data.text);
        this.type(data.object_type);
        this.url(data.url);
    }

    action() {
        window.open(this.url());
    }
}

class SearchManager {
    constructor() {
        this.searchUrl = 'https://api.healthshare.com.au/search/v1/all/';
        this.query = ko.observable('').extend({
            'rateLimit': 200,
            'method': 'notifyWhenChangesStop',
        });
        this.typedQuery = ko.observable();
        this.autoSetQuery = false;
        this.results = ko.observableArray();
        this.selectedIndex = ko.observable(-1);
        this.searching = ko.observable(false);

        this.keydown = this.keydown.bind(this);
        this.select = this.select.bind(this);

        // Track what user actually typed as we may interfere with query text
        this.query.subscribe((val) => {
            if (this.autoSetQuery) {
                // If flagged not to update, clean up flag
                this.autoSetQuery = false;
            } else {
                this.typedQuery(val);
            }
        });

        this.selected = ko.pureComputed(() => {
            if (this.selectedIndex() > -1) {
                return this.results()[this.selectedIndex()];
            }
        });

        // When selection changes, pre-fill text box(es) with result
        this.selected.subscribe((selection) => {
            if (!selection) {
                return;
            }
            const text = selection.text();
            this.autoSetQuery = true; // flag to typedQuery sub not to update
            this.query(text);
        });
        this.typedQuery.subscribe(() => {
            this.search(this.query(), true);
        });
    }

    keydown(_, event) {
        const key = event.key || event.keyCode || event.which;
        if (!this.results().length) {
            return true;
        }
        if (key === 38 || key === 'Up' || key === 'ArrowUp') {
            this.select(this.selectedIndex() - 1);
            return;
        } else if (key === 40 || key === 'Down' || key === 'ArrowDown') {
            this.select(this.selectedIndex() + 1);
            return;
        } else if (key === 27 || key === 'Esc' || key === 'Escape') {
            this.close();
        }
        return true;
    }

    select(index) {
        index = Math.max(Math.min(index, this.results().length - 1), 0);
        if (this.results()[index].selectable()) {
            this.selectedIndex(index);
        }
    }

    async search(query, clearResults) {
        // cancel previous request if still going
        if (this.searching()) {
            this.req.abort();
        }
        if (query) {
            this.query(query);
        }
        if (this.query().length < 3) {
            this.results([]);
            this.searching(false);
            return;
        }
        this.searching(true);

        const data = {
            q: this.query(),
            limit: 5,
            types: ['factsheet_categories', 'drugs'],
        };

        this.req = http.get({
            url: this.searchUrl,
            data,
        });
        const respData = await this.req;
        let results;

        if (clearResults) {
            results = [];
        } else {
            results = this.results();
        }

        this.selectedIndex(-1);

        if (!respData.results.length) {
            const noResult = new SearchResult();
            noResult.type('none');
            results.push(noResult);
        }

        for (const value of respData.results) {
            const result = new SearchResult();
            result.load(value);
            results.push(result);
        }
        if (respData.next) {
            const moreResults = new SearchResult();
            // eslint-disable-next-line max-len
            const searchUrl = `https://www.healthshare.com.au/factsheets/search/?q=${this.query()}`;
            moreResults.url(searchUrl);
            moreResults.type('more');
            results.push(moreResults);
        }

        this.results(results);
        this.searching(false);
    }

    // Close the dropdown, but don't clear the text
    close() {
        if (typeof isSearch !== 'undefined') {
            return;
        }

        if (this.searching()) {
            this.resultsDeferred.abort();
        }
        this.searching(false);
        setTimeout(() => {
            this.results([]);
            this.selectedIndex(-1);
        }, 50);
    }

    action() {
        if (this.selected()) {
            this.selected().action();
            return;
        }
        return true;
    }

    async load() {
        await events.ready();
        ko.applyBindings(this, document.getElementById('factsheets'));
    }
}

new SearchManager().load();
